const GIS_SCRIPT_SRC = 'https://accounts.google.com/gsi/client';
let gisLoadPromise = null;

export const loadGoogleIdentityScript = () => {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Google Identity Services unavailable'));
  }

  if (window.google?.accounts?.id) {
    return Promise.resolve(window.google);
  }

  if (gisLoadPromise) {
    return gisLoadPromise;
  }

  gisLoadPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector(`script[src="${GIS_SCRIPT_SRC}"]`);

    if (existingScript) {
      if (existingScript.getAttribute('data-loaded') === 'true') {
        resolve(window.google);
        return;
      }

      existingScript.addEventListener('load', () => resolve(window.google), { once: true });
      existingScript.addEventListener(
        'error',
        () => {
          gisLoadPromise = null;
          reject(new Error('Google Identity Services failed to load'));
        },
        { once: true }
      );
      return;
    }

    const script = document.createElement('script');
    script.src = GIS_SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      script.setAttribute('data-loaded', 'true');
      resolve(window.google);
    };
    script.onerror = () => {
      gisLoadPromise = null;
      reject(new Error('Google Identity Services failed to load'));
    };

    document.head.appendChild(script);
  });

  return gisLoadPromise;
};

export default loadGoogleIdentityScript;
